import { render, staticRenderFns } from "./ItemDelete.vue?vue&type=template&id=3c1d7090&scoped=true"
import script from "./ItemDelete.vue?vue&type=script&lang=js"
export * from "./ItemDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d7090",
  null
  
)

export default component.exports